/**
 * Possible columns for the chat history table
 */
export enum ColumnName {
    chatName = "chatName",
    chatSource = "chatSource",
    flagged = "flagged",
    messages = "messages",
    date = "date",
}
